import React from 'react'

import { createValidIcon } from '@ui/icons/utils/type-helper'

export const MetricsIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2 20C2 19.4477 2.44772 19 3 19H21C21.5523 19 22 19.4477 22 20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5 10C5 8.34315 6.34315 7 8 7C9.65685 7 11 8.34315 11 10V16C11 16.5523 10.5523 17 10 17C9.44772 17 9 16.5523 9 16V10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10V16C7 16.5523 6.55228 17 6 17C5.44772 17 5 16.5523 5 16V10Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13 6C13 4.34315 14.3431 3 16 3C17.6569 3 19 4.34315 19 6V16C19 16.5523 18.5523 17 18 17C17.4477 17 17 16.5523 17 16V6C17 5.44772 16.5523 5 16 5C15.4477 5 15 5.44772 15 6V16C15 16.5523 14.5523 17 14 17C13.4477 17 13 16.5523 13 16V6Z'
        fill={color}
      />
    </svg>
  )
})
